import { useMutation, useQueryClient } from "@tanstack/react-query";
import { serviceMapService } from "../../../services/serviceMapService";
import { businessServiceService } from "../../../services/businessServiceService";

export const useSystemRemoveDependents = () => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: async ({
      serviceMapId,
      systemId,
      dependents,
    }: {
      serviceMapId: string;
      systemId: string;
      dependents: string[];
    }) => {
      if (dependents.length === 0) {
        return serviceMapId;
      }
      const r = await businessServiceService.removeDependents(
        serviceMapId,
        systemId,
        dependents,
      );
      await serviceMapService.updateServiceStatuses(r);
      return r;
    },
    onSuccess: (serviceMapId) => {
      qc.invalidateQueries({ queryKey: ["serviceMapId", serviceMapId] });
      qc.invalidateQueries({ queryKey: ["dashboards"] });
    },
  });
};
